(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 1024px)';

  function modulo(value, length) {
    return length ? ((value % length) + length) % length : 0;
  }

  function init(root) {
    if (!root || root.dataset.ecendBound === 'true') return;
    root.dataset.ecendBound = 'true';

    var viewport = root.querySelector('[data-ecend-viewport]');
    var track = root.querySelector('[data-ecend-track]');
    if (!viewport || !track) return;

    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-ecend-slide]:not([data-ecend-clone])'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ecend-dot]'));
    var media = window.matchMedia(MOBILE_QUERY);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var physicalIndex = 1;
    var isMobile = false;
    var dragging = false;
    var pointerId = null;
    var startX = 0;
    var currentX = 0;
    var baseX = 0;
    var resizeTimer = null;

    function setOriginalA11y() {
      originals.forEach(function (slide, slideIndex) {
        var hidden = isMobile && slideIndex !== index;
        slide.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        if ('inert' in slide) slide.inert = hidden;
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function removeClones() {
      track.querySelectorAll('[data-ecend-clone]').forEach(function (clone) { clone.remove(); });
    }

    function sanitizeClone(clone) {
      clone.setAttribute('data-ecend-clone', 'true');
      clone.removeAttribute('data-block-id');
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
      if ('inert' in clone) clone.inert = true;
      return clone;
    }

    function buildClones() {
      removeClones();
      if (originals.length < 2) {
        physicalIndex = 0;
        return;
      }
      track.insertBefore(sanitizeClone(originals[originals.length - 1].cloneNode(true)), originals[0]);
      track.appendChild(sanitizeClone(originals[0].cloneNode(true)));
      physicalIndex = index + 1;
    }

    function transitionDuration() {
      return reduceMotion.matches ? '0ms' : '450ms';
    }

    function render(animate) {
      if (!isMobile) {
        track.style.transition = 'none';
        track.style.transform = '';
        setOriginalA11y();
        return;
      }
      track.style.transition = animate ? 'transform ' + transitionDuration() + ' cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
      track.style.transform = 'translate3d(' + (-physicalIndex * 100) + '%, 0, 0)';
      setOriginalA11y();
    }

    function goTo(targetIndex, animate) {
      if (!originals.length) return;
      index = modulo(targetIndex, originals.length);
      physicalIndex = originals.length < 2 ? 0 : index + 1;
      render(animate !== false);
    }

    function goRelative(direction) {
      if (originals.length < 2 || !isMobile) return;
      index = modulo(index + direction, originals.length);
      physicalIndex += direction;
      render(true);
    }

    function syncMode() {
      var nextMobile = media.matches;
      if (nextMobile !== isMobile) {
        isMobile = nextMobile;
        if (isMobile) buildClones();
        else removeClones();
      } else if (isMobile) {
        physicalIndex = originals.length < 2 ? 0 : index + 1;
      }
      render(false);
    }

    track.addEventListener('transitionend', function (event) {
      if (!isMobile || event.target !== track || event.propertyName !== 'transform' || originals.length < 2) return;
      if (physicalIndex === 0) {
        physicalIndex = originals.length;
        render(false);
      } else if (physicalIndex === originals.length + 1) {
        physicalIndex = 1;
        render(false);
      }
    });

    viewport.addEventListener('pointerdown', function (event) {
      if (!isMobile || originals.length < 2 || event.button > 0) return;
      dragging = true;
      pointerId = event.pointerId;
      startX = event.clientX;
      currentX = startX;
      baseX = -physicalIndex * viewport.clientWidth;
      track.style.transition = 'none';
      viewport.classList.add('is-dragging');
      try { viewport.setPointerCapture(pointerId); } catch (_error) {}
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!dragging || event.pointerId !== pointerId) return;
      currentX = event.clientX;
      var delta = currentX - startX;
      track.style.transform = 'translate3d(' + (baseX + delta) + 'px, 0, 0)';
      if (Math.abs(delta) > 4) event.preventDefault();
    });

    function endDrag(event) {
      if (!dragging || (event && event.pointerId !== pointerId)) return;
      var delta = currentX - startX;
      var threshold = Math.min(80, Math.max(42, viewport.clientWidth * 0.12));
      dragging = false;
      try { viewport.releasePointerCapture(pointerId); } catch (_error) {}
      pointerId = null;
      viewport.classList.remove('is-dragging');

      if (Math.abs(delta) >= threshold) goRelative(delta < 0 ? 1 : -1);
      else render(true);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);

    viewport.addEventListener('keydown', function (event) {
      if (!isMobile || originals.length < 2) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goRelative(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goRelative(1);
      }
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.ecendDot || '0', 10), true);
      });
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncMode, 120);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (event) {
        if (!root.contains(event.target)) return;
        var selected = event.target.closest('[data-ecend-slide]');
        if (!selected || selected.hasAttribute('data-ecend-clone')) return;
        goTo(parseInt(selected.dataset.ecendIndex || '0', 10), false);
      });
    }

    syncMode();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ecend]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
